var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.492,
    height: 31.648,
    viewBox: "0 0 29.492 31.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_17_",
    "data-name": "user (17)",
    transform: "translate(-17.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(17.44 17.826)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M32.186,288.389c-9.509,0-14.746,4.5-14.746,12.667a1.155,1.155,0,0,0,1.155,1.155H45.777a1.155,1.155,0,0,0,1.155-1.155C46.932,292.888,41.7,288.389,32.186,288.389ZM19.792,299.9c.454-6.108,4.618-9.2,12.394-9.2s11.94,3.094,12.395,9.2Z",
    transform: "translate(-17.44 -288.389)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(24.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M139.711,0a7.57,7.57,0,0,0-7.662,7.815c0,4.586,3.437,8.316,7.662,8.316s7.662-3.73,7.662-8.316A7.57,7.57,0,0,0,139.711,0Zm0,13.822c-2.951,0-5.352-2.694-5.352-6.006a5.252,5.252,0,0,1,5.352-5.506,5.311,5.311,0,0,1,5.352,5.506C145.063,11.128,142.662,13.822,139.711,13.822Z",
    transform: "translate(-132.049)",
    fill: "current"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.408a7f0e.svg";
export { ForwardRef as ReactComponent };